import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

type AnimatedContainerProps = {
  children: ReactNode;
  isVisible: Boolean;
  delay?: number;
  name: string;
};

const AnimatedContainer = ({
  isVisible,
  children,
  name,
  delay = 0,
}: AnimatedContainerProps) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        key={name}
        transition={{
          opacity: { duration: 0.3, ease: 'easeInOut' },
          height: { duration: 0.3, ease: 'easeInOut' },
          delayChildren: delay,
        }}
        style={{
          transformOrigin: 'top',
          overflow: 'hidden',
        }}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);

export default AnimatedContainer;
